import { FC, useContext, useEffect, useState } from 'react';
import { ProductTile } from '../ProductTile/ProductTile';
import { Box, Grid, useMediaQuery } from '@mui/material';
import { AvailableProduct, ProductsSlider, sopClient } from '@barracuda/shared/src';
import {
  productsListWrapperContainer,
  productsListWrapperProduct
} from './ProductsListWrapper.style';
import { useAddCartItem } from '../ExploreTests/useAddCartItem';
import { AppContext } from 'src/context/App.context';
import { ProductMetadata } from '@barracuda/shared/src/interface/products.interface';

export const ProductsListWrapper: FC = () => {
  const { eCommerceCountryISO2 } = useContext(AppContext);

  const [products, setProducts] = useState<AvailableProduct[] | []>([]);
  const below675px = useMediaQuery('(max-width: 675px)');
  useEffect(() => {
    fetchAvailableProducts();
  }, []);
  const fetchAvailableProducts = async () => {
    const response = await sopClient.getAvailableProducts();
    const { data } = response;
    setProducts(data.results.filter((p: AvailableProduct) => !!p.essId));
  };
  const addCartItem = useAddCartItem();

  const parseProductMetadata = (metadata: ProductMetadata) => {
    const time = Number(metadata.TEST_DURATION);
    const skills = JSON.parse(metadata.TEST_SKILLS);
    return {
      skills,
      time
    };
  };

  return (
    <>
      {!below675px && (
        <Grid container sx={productsListWrapperContainer}>
          {products?.map((item, index) => (
            <Grid item sx={productsListWrapperProduct} key={`product-${index}`}>
              <ProductTile
                type='buy'
                data={parseProductMetadata(item.metadata)}
                essId={item.essId}
                handleBuy={addCartItem}
                eCommerceCountryISO2={eCommerceCountryISO2 || 'US'}
              />
            </Grid>
          ))}
        </Grid>
      )}
      {below675px && (
        <Box
          sx={{
            marginLeft: '-10px',
            ' & > div': { width: 'calc(100% + 10px)' }
          }}
        >
          <ProductsSlider maxSteps={products.length}>
            {products?.map((item, index) => (
              <Box sx={{ marginInline: '10px' }} key={`product-${index}`}>
                <ProductTile
                  type='buy'
                  data={parseProductMetadata(item.metadata)}
                  essId={item.essId}
                  handleBuy={addCartItem}
                  eCommerceCountryISO2={eCommerceCountryISO2 || 'US'}
                />
              </Box>
            ))}
          </ProductsSlider>
        </Box>
      )}
    </>
  );
};
